import React from "react";
import styled from "styled-components";
import numeral from "numeral";
import { green } from "@material-ui/core/colors";
import Typography from "@material-ui/core/Typography";
import DollarIcon from "@material-ui/icons/MonetizationOn";

const DealerCashHeader = styled(Typography).attrs({
  color: "primary",
  variant: "h3"
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GreenDollarIcon = styled(DollarIcon)`
  color: ${green[600]};
`;

const DealerCash = ({ vehicle, amount, name }) => (
  <div>
    <DealerCashHeader>
      <GreenDollarIcon />
      Dealer Bonus Cash
      <GreenDollarIcon />
    </DealerCashHeader>
    <Typography variant="body2" color="textPrimary">
      {name} is looking for a {vehicle} just like yours. As an added bonus,
      bring in a printed copy of this trade in report for an additional Dealer
      Bonus Cash of up to {numeral(amount).format("$0,0")}.
    </Typography>
  </div>
);

export default DealerCash;
